import { put, takeLatest, call } from 'redux-saga/effects';
import { POST } from '../consts/Methods';
import { NEW_PASSWORD_REQUEST, NEW_PASSWORD_REQUEST_FAIL, NEW_PASSWORD_REQUEST_SUCCESS } from '../redux/authReducer';
import apiCall from '../helpers/ApiCall';

function* newPasswordRequestFlow({ payload, }) {
  try {
    const endpoint = '/dealers/auth/forgot_password';
    const params = { dealer: { email: payload, }, };
    yield call(apiCall, { endpoint, method: POST, params, });
    yield put(NEW_PASSWORD_REQUEST_SUCCESS())
  } catch (error) {
    yield put(NEW_PASSWORD_REQUEST_FAIL(error));
  }
}

export default function* NewPasswordRequest() {
  yield takeLatest(NEW_PASSWORD_REQUEST, newPasswordRequestFlow);
}
